import type { Notification } from '@/types';

export const mockNotifications: Notification[] = [
  {
    id: 'n_1',
    title: 'Dashboard shared',
    message: 'Sales Dashboard was shared with your team.',
    level: 'info',
    read: false,
    createdAt: new Date(Date.now() - 60_000 * 5).toISOString(),
  },
  {
    id: 'n_2',
    title: 'Report ready',
    message: 'Monthly Executive Report is ready for download.',
    level: 'success',
    read: false,
    createdAt: new Date(Date.now() - 60_000 * 30).toISOString(),
  },
  {
    id: 'n_3',
    title: 'System alert',
    message: 'API latency exceeded threshold.',
    level: 'warning',
    read: true,
    createdAt: new Date(Date.now() - 60_000 * 60 * 5).toISOString(),
  },
];
